export default __webpack_public_path__ + "components/weather-icon/static/nightlightsnow@3-bdf0939357de3879ef5e96a9d3490791.png";